/**
 * Legacy /register route — redirects to the unified /login screen.
 * IMPORTANT: preserve `?ref=CODE` so referral attribution survives the
 * redirect. Without this, share links like /register?ref=XYZ landed on
 * /login with an empty query and the referrer got zero credit.
 */
import { Navigate, useLocation } from "react-router-dom";

const Register = () => {
  const location = useLocation();
  const target = location.search ? `/login${location.search}` : "/login";
  return <Navigate to={target} replace />;
};

export default Register;
